<template>
	<div>Colors</div>
</template>

<script>
export default {
	name: "Colors",
	props: {},
	data() {
		return {};
	},
	computed: {},
	methods: {}
}
</script>

<style lang="scss" scoped>
::v-deep #product-req-table td {
	vertical-align: top !important;
}
</style>
